export const GET_COMPLAINS = "GET_COMPLAINS";
export const GET_COMPLAINS_SUCCESS = "GET_COMPLAINS_SUCCESS";
export const GET_COMPLAINS_ERROR = "GET_COMPLAINS_ERROR";

export const GET_COMPLAIN = "GET_COMPLAIN";
export const GET_COMPLAIN_SUCCESS = "GET_COMPLAIN_SUCCESS";
export const GET_COMPLAIN_ERROR = "GET_COMPLAIN_ERROR";

export const SEND_COMPLAIN_REPLY = "SEND_COMPLAIN_REPLY";
export const SEND_COMPLAIN_REPLY_SUCCESS = "SEND_COMPLAIN_REPLY_SUCCESS";
export const SEND_COMPLAIN_REPLY_ERROR = "SEND_COMPLAIN_REPLY_ERROR";
export const TOGGLE_NOTIFICATION_REPLY_MODAL =
  "TOGGLE_NOTIFICATION_REPLY_MODAL";
